import React, {useMemo} from "react";
import {Helmet} from "react-helmet";
import GameModeMenu from "../../components/Servers/GameModeMenu";
import ServerGrid from "../../components/Servers/ServerGrid";
import {useParams} from "react-router";
import getAllServers from "../../data/getAllServers.json";
import {GAME_MODE_CONFIG} from "../../config";

const Servers = () => {
    const { slug } = useParams();

    const mode = useMemo(() => {
      let mode = null;

      if (slug) {
        Object.keys(GAME_MODE_CONFIG).map((modeId) => {
          if (GAME_MODE_CONFIG[modeId].slug === slug) {
            mode = {
              id: Number(modeId),
              ...GAME_MODE_CONFIG[modeId]
            };
          }
          return false;
        });
      }

      return mode;
    }, [slug]);

    const serversList = useMemo(() => {
      return getAllServers.serversList.filter((server) => server.GameModeID === mode.id);
    }, [mode]);

    return (
        <>
            <Helmet
                title={mode?.h1}
                meta={[
                    {"name": "description", "content": mode?.shortDesc.en}
                ]}
            />

            <GameModeMenu slug={slug} />
            <ServerGrid serversList={serversList} />
        </>
    );
};

export default Servers;